/* Mobile sticky add to cart bar.
   Builds its own markup and submits the real buy box form, so the selected
   plan, quantity and variant are never duplicated or allowed to drift. */
(function () {
  function txt(el) { return el ? el.textContent.trim() : ''; }

  function init(root) {
    var buy = root.querySelector('[data-buybox]');
    if (!buy) return;
    if (root.querySelector('[data-sticky]')) return;

    var form = buy.querySelector('form');
    var cta = buy.querySelector('[data-cta]');
    var plans = buy.querySelector('[data-plans]');
    if (!form || !cta) return;

    var bar = document.createElement('div');
    bar.className = 'pdp-sticky';
    bar.setAttribute('data-sticky', '');
    bar.innerHTML =
      '<div class="ps-in">' +
        '<div class="ps-info">' +
          '<b data-sticky-label></b>' +
          '<span><i data-sticky-price></i><s data-sticky-was></s></span>' +
        '</div>' +
        '<button type="button" class="btn" data-sticky-cta></button>' +
      '</div>';
    root.appendChild(bar);

    var lab = bar.querySelector('[data-sticky-label]');
    var pri = bar.querySelector('[data-sticky-price]');
    var was = bar.querySelector('[data-sticky-was]');
    var btn = bar.querySelector('[data-sticky-cta]');

    btn.textContent = cta.getAttribute('data-label') || txt(cta) || 'Add to cart';

    /* mirror whichever plan is currently selected, including the prices that
       pdp.js writes in after the household selector changes */
    function sync() {
      var on = plans ? plans.querySelector('.plan.on') : null;
      if (!on) return;
      var price = txt(on.querySelector('[data-price]'));
      var wasV = txt(on.querySelector('[data-was]'));
      lab.textContent = txt(on.querySelector('.pmain b'));
      pri.textContent = price;
      was.textContent = (wasV && wasV !== price) ? wasV : '';
    }

    sync();

    if (plans && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(plans, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    btn.addEventListener('click', function () {
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });

    /* show only once the real button has scrolled up out of view */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
        }
      }, { threshold: 0 }).observe(cta);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('.pdp');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
